import { createAsyncThunk } from '@reduxjs/toolkit';

import { store } from '@/Infrastructure/State';
import type { Pickup } from '@/modules/pickup/domain/Pickup';
import type { PickupRepository } from '@/modules/pickup/domain/PickupRepository';

import { pickupSessionStorageRepository } from '../PickupSessionStorageRepository';

const SAVE_PICKUP = 'pickups/savePickup';
const FETCH_PICKUPS = 'pickups/fetchPickups';
const FIND_PICKUPS = 'picups/findPickups';

export const savePickup = createAsyncThunk(
  SAVE_PICKUP,
  async (payload: Pickup | Omit<Pickup, 'id'>) => {
    const pickup = await pickupSessionStorageRepository.save(payload);

    return pickup;
  }
);

export const fetchPickups = createAsyncThunk(FETCH_PICKUPS, async () => {
  const pickups = await pickupSessionStorageRepository.getAll();
  return pickups;
});

export const findPickups = createAsyncThunk(
  FIND_PICKUPS,
  async (deliveryId: number) => {
    const pickups =
      await pickupSessionStorageRepository.getByDeliveryId(deliveryId);
    return pickups;
  }
);

const PickupReduxRepository: PickupRepository = {
  getAll: async () => {
    const { payload } = await store.dispatch(fetchPickups());
    return payload as Pickup[];
  },
  save: async (pickupPayload) => {
    const { payload } = await store.dispatch(savePickup(pickupPayload));
    return payload as Pickup;
  },
  getByDeliveryId: async (deliveryId) => {
    const { payload } = await store.dispatch(findPickups(deliveryId));
    return payload as Pickup[];
  }
};

export default PickupReduxRepository;
